export const SIGNUP_ROOT_ROUTE = 'SignUp'

export const subRoutes = {
  contactDetailsError: `/error`,
  password: `/password`,
  verificationOptions: `/options`,
  security: `/security`,
  depositLimit: `/deposit-limit`,
  depositBonus: `/deposit-bonus`,
  driversLicence: `/licence`,
  passport: `/passport`,
  medicare: `/medicare`,
  failGeneral: `/fail-general`,
  signUpUnsuccessful: `/unsuccessful`,
  signUpComplete: `/complete`,
} as const

const withRoot = (path: string) => `/${SIGNUP_ROOT_ROUTE}${path}`
export const routes = {
  contactDetails: `/${SIGNUP_ROOT_ROUTE}`,
  contactDetailsError: withRoot(subRoutes.contactDetailsError),
  password: withRoot(subRoutes.password),
  verificationOptions: withRoot(subRoutes.verificationOptions),
  security: withRoot(subRoutes.security),
  depositLimit: withRoot(subRoutes.depositLimit),
  depositBonus: withRoot(subRoutes.depositBonus),
  driversLicence: withRoot(subRoutes.driversLicence),
  passport: withRoot(subRoutes.passport),
  medicare: withRoot(subRoutes.medicare),
  failGeneral: withRoot(subRoutes.failGeneral),
  signUpUnsuccessful: withRoot(subRoutes.signUpUnsuccessful),
  signUpComplete: withRoot(subRoutes.signUpComplete),
  home: `/`,
} as const
